import useBreakpoint from "./useBreakpoint";

export default () => {
	return useBreakpoint("(max-width: 600px)");
};
